/* eslint-disable */
(function() {
  var $ = require('jquery');
  var _ = require('underscore');
  require('chosen-js/chosen.jquery.min.js');

  // Initialise chosen.
  initialise();

  // Add resize event listener.
  $(window).resize(_.debounce(initialise, 100));

  /** Initialise */
  function initialise() {
    if (!isMobileOrTablet() && window.matchMedia('screen and (min-width: 768px)').matches) {
      var $select = $('select:not([data-ignore])');

      if (!$select.hasClass('chosen-select')) {
        $select.addClass('chosen-select');
      }

      $('.chosen-select').chosen({
        // jshint camelcase:false
        disable_search_threshold: 10,
        // jshint camelcase:true
      });
    } else {
      $('.chosen-select').chosen('destroy');
    }
  }

  /** Check if device is iOS or Android. */
  function isMobileOrTablet() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check user agent for iOS devices.
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
      return true;
    }

    // Check user agent for Android devices.
    if (userAgent.match(/Android/i)) {
      return true;
    }

    // Assume everything else is not mobile or tablet.
    return false;
  }
})();
